import { BooleanField, BooleanInput, Create, Datagrid, DateField, Edit, List, PasswordInput, ReferenceField, SimpleForm, TextField, TextInput } from 'react-admin';

export const UsersList = () => (
    <List>
        <Datagrid rowClick="edit"
            isRowSelectable={(record) => false}
        >
            <TextField source="id" />
            <TextField source="username" />
            <BooleanField source="status" />
            <DateField source="createdAt" />
            <ReferenceField source="createdBy" reference="administrators">
                <TextField source="email" />
             </ReferenceField>
            <TextField source="ua" />
            <TextField source="updatedAt" />
            <ReferenceField source="updatedBy" reference="administrators">
                <TextField source="email" />
             </ReferenceField>
        </Datagrid>
    </List>
);

export const UsersEdit = (props: any) => {
    return (
        <Edit title='Users'>
            <SimpleForm>
                <TextInput source="username" fullWidth disabled />
                <PasswordInput source="password" fullWidth />
                <TextInput source="name" fullWidth />
                <TextInput source="email" fullWidth />
                <BooleanInput source="status" />
            </SimpleForm>
        </Edit>
    )
}

export const UsersCreate = (props: any) => {
    return (
        <Create title='Users'>
            <SimpleForm>
                <TextInput source="username" fullWidth required />
                <PasswordInput source="password" fullWidth required />
                <TextInput source="name" fullWidth />
                <TextInput source="email" fullWidth />
                <BooleanInput source="status" defaultValue={ true }/>
            </SimpleForm>
        </Create>
    )
}